import * as React from 'react'
import type { SVGProps } from 'react'
export interface GitPullRequestIconProps extends SVGProps<SVGSVGElement> {
  size?: number | string
}
/**
 * git-pull-request
 * Tabler Icons
 * @url https://icon-sets.iconify.design/tabler
 * @license MIT
 */
export const GitPullRequestIcon = (props: GitPullRequestIconProps) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      {...props}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path d="M4 18a2 2 0 1 0 4 0a2 2 0 1 0-4 0M4 6a2 2 0 1 0 4 0a2 2 0 1 0-4 0m12 12a2 2 0 1 0 4 0a2 2 0 1 0-4 0M6 8v8" />
        <path d="M11 6h5a2 2 0 0 1 2 2v8" />
        <path d="m14 9l-3-3l3-3" />
      </g>
    </svg>
  )
}
